


<div>
  <div style="margin-left: 80%; margin-bottom: 2%;" class="noPrint">
    <button [useExistingCss]="true"
            style="margin-right: 2%; margin-left: 2%; z-index: 10;font-size: 12px; font-weight: 600;"
            mat-raised-button color="primary"  printSectionId="print-section2" ngxPrint>
      Print
    </button>
    <button mat-dialog-close class="btn" style="z-index: 10">Close</button>
  </div>

  <div class="wrapper" id="print-section2">
    <!-- Fixed Header -->
    <div class="header">

                <span *ngIf="isNotBlank(data?.start_date)">पासुन दिनांक: {{ data.start_date | date: 'dd-MM-yyyy'}} | </span>
                <span *ngIf="isNotBlank(data?.end_date)">पर्यत दिनांक: {{ data.end_date | date: 'dd-MM-yyyy'}} | </span>
                <span *ngIf="isNotBlank(data?.country)">देश: {{data.country}} | </span>
                <span *ngIf="isNotBlank(data?.state_name)">राज्य: {{ getStateName(data.state_name) }}  | </span>
                <span *ngIf="isNotBlank(data?.district_name)">जिल्हा: {{data.district_name}} | </span>
                <span *ngIf="isNotBlank(data?.taluka_name)">तालुका: {{data.taluka_name}} | </span>
                <span *ngIf="isNotBlank(data?.rep_name)">प्रतिनिधी: {{data.rep_name}} | </span>
                <span *ngIf="isNotBlank(data?.delivery_mode)">वितरण मोड: {{data.delivery_mode}}  | </span>
                <span *ngIf="isNotBlank(data?.subtype)">सदस्यता प्रकार: {{data.subtype}} | </span>
                <span *ngIf="isNotBlank(data?.prant_name)">प्रांत: {{data.prant_name}}</span>
                <span *ngIf="isNotBlank(data?.subno)">वर्गणी.क्र : {{data.subno}}</span>
                <span *ngIf="isNotBlank(data?.crdt_voucher_no)">व्हाउचर क्र: {{data.crdt_voucher_no}}</span>
                <span *ngIf="isNotBlank(data?.rcpt_no)">पावती क्र.: {{data.rcpt_no}}</span>
                <span *ngIf="isNotBlank(data?.office_rep_name)">कार्यालय प्रतिनिधी: {{data.office_rep_name}}</span>
                <span *ngIf="isNotBlank(data?.name)">सदस्याचे नाव: {{data.name}}</span>
    </div>

    <!-- Content Grid -->
    <div class="print-grid">
      <ng-container *ngFor="let data of subscriberdetailsbrief; let i = index">
        <div class="grid-item">
          <span style="font-size: 14px; font-weight: bold;">
            {{ getShortSubtype(data?.subtype) }}.{{ data?.sub_perid_to_date | date:'MM' }}/{{ data['subno'] }}-{{ data?.sub_perid_to_date | date:'yyyy' }}
          </span><br />

          <span *ngIf="data.address?.length > 94" style="font-size: 13px; font-weight: bold;">
           {{ data["name"] }}
          </span>
          <span *ngIf="data.address?.length <= 94" style="font-size: 15px; font-weight: bold;">
            {{ data["title"] }} {{ data["name"] }}
          </span><br />

          <span style="font-weight: bold; display: block;"
                [style.font-size.px]="data.address?.length > 94 ? 13 : 15">
            {{ data["address"] }}
          </span>
          <span *ngIf="data.taluka" style="font-weight: bold; display: block;"
                [style.font-size.px]="data.address?.length > 94 ? 13 : 15">
            {{ data["taluka"] }}
          </span>
          <span *ngIf="data['pincode'] != 0" style="font-weight: bold;"
                [style.font-size.px]="data.address?.length > 94 ? 13 : 15">
            <span *ngIf="data.district">{{ data["district"] }} - </span>
            {{ data["pincode"] }} {{ data["state"] }}  मो.क्र.-{{ data["mobileNumber"] }}
          </span>
        </div>
      </ng-container>
    </div>
  </div>
</div>

